import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonGroup, StackView, Typography } from '@telus-uds/components-web';
export var CategoryFilters = function (_a) {
    var categories = _a.categories, machineNameCategories = _a.machineNameCategories, deviceCount = _a.deviceCount, activeCategoryFilter = _a.activeCategoryFilter, handleOnClick = _a.handleOnClick, _b = _a.label, label = _b === void 0 ? '' : _b;
    var categoryOptions = categories.map(function (option, i) {
        return {
            label: "".concat(option, " (").concat(deviceCount[i], ")"),
            value: machineNameCategories[i],
            id: machineNameCategories[i]
        };
    });
    var initialValues = categoryOptions
        .filter(function (c) { return c.value === activeCategoryFilter; })
        .map(function (c) { return c.value; });
    return (_jsxs(StackView, { space: 1, children: [_jsx(Typography, { variant: { bold: true }, children: label }), _jsx(ButtonGroup, { items: categoryOptions, onChange: handleOnClick, values: initialValues })] }));
};
